import * as React from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "./Icon";

type CarouselArrowProps = {
  direction: "prev" | "next";
  onClick: () => void;
  disabled?: boolean;
  /** Accessible label override. Defaults to "Previous" / "Next". */
  label?: string;
};

export function CarouselArrow({ direction, onClick, disabled = false, label }: CarouselArrowProps) {
  const { t } = useTranslation("ui");
  const fallback = direction === "prev" ? t("previous") : t("next");
  const a11yLabel = label ?? fallback;
  return (
    <button
      type="button"
      aria-label={a11yLabel}
      onClick={onClick}
      disabled={disabled}
      className={[
        "inline-flex h-12 w-12 items-center justify-center rounded-full",
        "bg-white border border-primary/15 text-primary text-[20px]",
        "shadow-[var(--shadow-card)] transition-[border-color,box-shadow,opacity] duration-200",
        "hover:border-primary/35 hover:shadow-[var(--shadow-card-hover)]",
        "focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 focus-visible:ring-offset-2",
        "disabled:opacity-40 disabled:pointer-events-none disabled:shadow-[var(--shadow-card)]",
      ].join(" ")}
    >
      <Icon name={direction === "prev" ? "chevron-left" : "chevron-right"} />
    </button>
  );
}
